import { Component, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

export interface UiActionToastData {
  message: string;
  /** Label of the inline action (e.g. "Undo"); omit to show only the message. */
  actionLabel?: string;
}

/**
 * Dark confirmation toast with an optional inline action, rendered inside a MatSnackBar.
 * Open it through `UiActionToastService`; the action resolves the ref's `onAction()`.
 */
@Component({
  selector: 'app-ui-action-toast',
  standalone: true,
  templateUrl: './ui-action-toast.component.html',
  styleUrl: './ui-action-toast.component.css',
})
export class UiActionToastComponent {
  readonly data = inject<UiActionToastData>(MAT_SNACK_BAR_DATA);
  private readonly snackBarRef = inject(MatSnackBarRef);

  action(): void {
    this.snackBarRef.dismissWithAction();
  }

  dismiss(): void {
    this.snackBarRef.dismiss();
  }
}
